import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const routes = [
  { path: "/login", component: () => import("@/views/Login.vue") },
  {
    path: "/seleccionar-empresa",
    component: () => import("@/views/CompanySelection.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },
  {
    path: "/existencias",
    component: () => import("@/views/Existencias.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },
  {
    path: "/estado-financiero",
    component: () => import("@/views/EstadoFinanciero.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },
  {
    path: "/cuentas",
    component: () => import("@/views/Cuentas.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },
  {
    path: "/movimientos-financieros",
    component: () => import("@/views/MovimientosFinancieros.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },
  {
    path: "/prestamos",
    component: () => import("@/views/Prestamos.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },
  {
    path: "/ventas",
    component: () => import("@/views/Ventas.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },
  {
    path: "/ventas/nueva",
    component: () => import("@/views/VentasForm.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },

  {
    path: "/",
    component: () => import("@/views/Dashboard.vue"),
    meta: { requiresAuth: true, requiresCompany: true },
  },

  // {
  //   path: "/",
  //   component: () => import("@/App.vue"),
  //   // component: () => import("@/views/HomeView.vue"),
  //   redirect: "/dashboard",
  //   children: [
  //     {
  //       path: "dashboard",
  //       component: () => import("@/views/Dashboard.vue"),
  //       meta: { requiresAuth: true, requiresCompany: true },
  //     },
  //     {
  //       path: "existencias",
  //       component: () => import("@/views/Existencias.vue"),
  //       meta: { requiresAuth: true, requiresCompany: true },
  //     },
  //     // ... Definir todas las demás rutas aquí
  //   ],
  // },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  if (to.meta.requiresAuth && !authStore.token) {
    next("/login");
  } else if (to.meta.requiresCompany && !authStore.selectedCompany) {
    next("/seleccionar-empresa");
  } else {
    next();
  }
});

export default router;
